<template>
  <router-link
     v-if="isRouter"
    :to="to"
    @click.native="onClick"
    class="square-button"
    :class="{ 'is-active': isActive, 'is-light': !isDark }"
    :tag="'div'"
    :style="{ color: fontColor }"
  >
    <slot />
    <span v-if="showBadge && notification > 0" class="square-button__badge">{{
      notificationCount
    }}</span>
  </router-link>
  <a v-else href="#" @click="onClick" class="square-button" :class="{ 'is-active': isActive, 'is-light': !isDark }">
      <slot />
      <span v-if="showBadge && notification > 0" class="square-button__badge">
          {{
      notificationCount
          }}
      </span>
  </a>

</template>

<script>
export default {
  name: "SquareButton",
  props: {
    notification: {
      type: Number,
      required: false,
      default: () => 0
    },
    color: {
      type: String,
      required: false
    },
    to: {
      type: String,
      required: false,
      default: () => ""
    },
    isActive: {
      type: Boolean,
      required: false
    },
    onClick: {
      type: Function,
      required: false,
      default: () => 0
    },
    isDark: {
      type: Boolean,
      default: () => true
    },
    showBadge: {
      type: Boolean,
      default: () => true
    }
  },
        computed: {
            isRouter() {
                return this.hasOwnProperty("$router");
            },
    notificationCount() {
      if (this.notification < 10) return this.notification;
      return "10+";
    },
    fontColor() {
      let color;
      if (!this.notification && this.isDark) color = "#fff";
      else if (!this.notification && !this.isDark) color = "#5b5b5b";
      if (this.notification && this.color) return this.color;
      return color;
    }
  }
};
</script>

<style  scoped lang="scss">
.square-button {
  display: flex;
  position: relative;
  justify-content: center;
  align-items: center;
  width: 2.6rem;
  height: 2.6rem;
  border-radius: 4px;
  box-sizing: border-box;
  cursor: pointer;
  user-select: none;
}

.square-button:hover {
  background-color: #ffffff0c;
}

.square-button:active,
.square-button.is-active {
  background-color: #ffffff2d;
}

.square-button.is-light:hover {
  background-color: #0000000f;
}

.square-button.is-light:active,
.square-button.is-light.is-active {
  background-color: #0000001a;
}

.square-button__badge {
  font-size: 0.75em;
  margin-left: 0.25em;
}
</style>
